import React from "react";
export default function ProgressBar({ currentStep, totalSteps }) {
  const progress = Math.floor(((currentStep - 1) / totalSteps) * 100);
  return (
    <div className="block w-full mb-5">
      <div className="flex items-center justify-between">
        <div className="inline-flex items-start justify-start mr-2 w-full h-2.5 rounded-xl bg-gray-200">
          <span
            className="inline-flex h-full bg-brand-500 rounded-xl"
            style={{ width: `${progress}%` }}
          ></span>
        </div>
        <span className="text-xs text-primary-700">{progress}%</span>
      </div>
    </div>
  );
}
